import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type NowSlotExtended } from '@redteclab/api/clients/bully'

import { NowTimeLeftCounter } from '../../../../../now'

export const ProductBuyBoxNowInfoCountdown: FC<{
  nowSlot: NowSlotExtended
}> = ({ nowSlot }) => {
  return (
    <span className="mr-1">
      <FormattedMessage
        id="nowCountdown.ifYouBuyInXMinutes"
        values={{
          countdown: (
            <NowTimeLeftCounter className="font-bold" nowSlot={nowSlot} />
          ),
        }}
      />
    </span>
  )
}
